import { TownshipBase } from './base/township-base';

export class Township extends TownshipBase { }